// src/api/QrCodeController.js

import axios from 'axios';

const BASE_URL = 'https://mototaksi.az:9999/api/v6/qrcode';

const QrCodeController = {
  // Bütün QR kodları gətir
  getAllQRCodes: async () => {
    try {
      const response = await axios.get(BASE_URL);
      return response.data;
    } catch (error) {
      console.error('QR kodlar alınarkən xəta:', error);
      throw error;
    }
  },

  // ID-yə görə QR kodu gətir
  getQRCodeById: async (qrCodeId) => {
    try {
      const response = await axios.get(`${BASE_URL}/${qrCodeId}`);
      return response.data;
    } catch (error) {
      console.error(`ID ${qrCodeId} üçün QR kod alınarkən xəta:`, error);
      throw error;
    }
  },

  // Yeni QR kod yarat
  createQRCode: async (qrCodeData) => {
    try {
      const response = await axios.post(BASE_URL, qrCodeData);
      return response.data;
    } catch (error) {
      console.error('QR kod yaradılarkən xəta:', error);
      throw error;
    }
  },

  // QR kodu yenilə
  updateQRCode: async (qrCodeId, qrCodeData) => {
    try {
      const response = await axios.put(`${BASE_URL}/${qrCodeId}`, qrCodeData);
      return response.data;
    } catch (error) {
      console.error(`QR kod ID ${qrCodeId} yenilənərkən xəta:`, error);
      throw error;
    }
  },

  // QR kodu sil
  deleteQRCode: async (qrCodeId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${qrCodeId}`);
      return response.data;
    } catch (error) {
      console.error(`QR kod ID ${qrCodeId} silinərkən xəta:`, error);
      throw error;
    }
  },
};

export default QrCodeController;
